import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './mid_energy_icon_online.svg'

const MidEnergyIconOnline: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} fill="currentColor" />
export default MidEnergyIconOnline
